module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Landing-Page-w720.38f13d61.webp";